import validateVATNumber from '../helpers/validateVATNumber';

const $billingForm = $('#billing-form-container');
const euCountries = [
  'AT', 'BE', 'BG', 'CY', 'CZ', 'DK', 'EE', 'ES', 'FI', 'FR',
  'DE', 'GB', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT',
  'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'HR'
];
const $countryField = $billingForm.find('#countries_select');
const $vatField = $billingForm.find('#vat_field');
const $vatContainer = $billingForm.find('.add-vat-group');
const $vatAccordion = $billingForm.find('#want-vat');
const $localeCountry = $billingForm.find('#locale-country');
const updateBillingDetailsText = $('#update_billing_details').text();
const pleaseFillFormText = $('#billing_details_please_fill_info').text();
let countryFromFront = null;

$billingForm.find('#want-address').click();

// Setting the country in the select
if ($localeCountry) {
  countryFromFront = $localeCountry.val().toUpperCase();
}

if (countryFromFront && countryFromFront.length === 2) {
  $countryField.val(countryFromFront);
} else {
  $countryField.val(null);
}

function countryPermitsVatCheck () {
  if (euCountries.includes($countryField.val())) {
    $vatContainer.removeClass('hidden').collapse('show');
    $billingForm.find('.vat_number').collapse('show');
    $vatField.val('');
  } else {
    $vatContainer.addClass('hidden').collapse('hide');
    $billingForm.find('.vat_number').collapse('hide');
    $vatField.val('');
  }
}

// Hide or show vat depending on the country selected before
if (euCountries.includes($countryField.val())) {
  $vatContainer.removeClass('hidden').collapse('show');
  $vatAccordion.click();
}

// Hide or show vat on country changed
$countryField.change(function () {
  countryPermitsVatCheck();
});

// Validate first name last name and country for sending form
$billingForm.find('.required').on('keyup change', function () {
  const firstNameValue = $('#first_name_field').val() || '';
  const lastNameValue = $('#last_name_field').val() || '';
  const countryValue = $countryField.val() || '';
  const isCountryValid = countryValue.length > 0;
  const isFirstNameValid = firstNameValue.trim().length > 0;
  const isLastNameValid = lastNameValue.trim().length > 0;
  const formIsValid = isFirstNameValid && isLastNameValid && isCountryValid;

  $('#first_name_field')
    .toggleClass('invalid', !isFirstNameValid)
    .next('.error')
    .toggleClass('hidden', isFirstNameValid);

  $('#last_name_field')
    .toggleClass('invalid', !isLastNameValid)
    .next('.error')
    .toggleClass('hidden', isLastNameValid);

  if (formIsValid) {
    updateSubmitButton(formIsValid);
  } else {
    updateSubmitButton(formIsValid);
  }
});

// Validating vat field
$vatField.keyup(function () {
  const vat = $vatField.val();
  let isValid = validateVATNumber(vat);
  updateVatField(isValid);
  updateSubmitButton(isValid);
});

function updateVatField (isValid) {
  $billingForm.find('#vat_field')
    .toggleClass('invalid', !isValid)
    .toggleClass('valid', isValid)
    .parent()
    .find('.error')
    .toggleClass('hidden', isValid);
}

function updateSubmitButton (isValid) {
  const submitText = isValid ? updateBillingDetailsText : pleaseFillFormText;
  $billingForm.find('.js-billing-details_submit')
    .attr('disabled', !isValid)
    .text(submitText);
}
